var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"loading":_vm.loading}},[(!_vm.loading)?[_c('d-header',{attrs:{"fluid":"","actions":[
        {
          label: _vm.$t('save'),
          primary: true,
          color: 'is-primary',
          action: _vm.submitForm,
        },
      ]}},[_c('h1',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.model.name)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"max-w-3xl"},[_c('v-form',{ref:"form",attrs:{"action":"edit","model":_vm.model}})],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }